module.exports = __webpack_public_path__ + "static/img/it4d-consciente.f3a774e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/it4d-consciente.png
// module id = BQ2b
// module chunks = 4